import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { refsActions, refsEpic, refsReducer, RefsState } from './refs'
import { rolesActions, rolesEpic, rolesReducer, RolesState } from './roles'
import { permissionsActions, permissionsEpic, permissionsReducer, PermissionsState } from './permissions'
import { profileActions, profileEpic, profileReducer, ProfileState } from './profile'
import { configActions, configEpic, configReducer, ConfigState } from './config'
import { usersActions, usersEpic, usersReducer, UsersState } from './users'

export const settingsActions = {
    configActions,
    permissionsActions,
    profileActions,
    refsActions,
    rolesActions,
    usersActions,
}

export interface SettingsState {
    config: ConfigState,
    permissions: PermissionsState,
    profile: ProfileState,
    refs: RefsState,
    roles: RolesState,
    users: UsersState,
}

export const settingsReducer = combineReducers<SettingsState>({
    config: configReducer,
    permissions: permissionsReducer,
    profile: profileReducer,
    refs: refsReducer,
    roles: rolesReducer,
    users: usersReducer,
})

export const settingsEpic = combineEpics(configEpic, permissionsEpic, profileEpic, refsEpic, rolesEpic, usersEpic)